export default "__VITE_ASSET__Tl0xLLNd__"